import { createSlice } from '@reduxjs/toolkit';
import { addNewSkill, editSkill, getAllSkills } from './skillService';

const initialState = {
  allSkills: {
    isSkillsLoading: null,
    isSkillsSuccess: null,
    skillsMessage: null,
    pageCount: 0,
    skills: [],
  },
  newSkill: {
    isSkillCreating: null,
    isSkillCreated: null,
    skillCreationMsg: null,
  },

  editedSkill: {
    isEditingSkill: null,
    isSkillEdited: null,
    skillEditedMsg: null
  }
};

const skillsSlice = createSlice({
  name: 'skill',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllSkills.pending, (state) => {
        state.allSkills = {
          ...initialState.allSkills, // Reset to initial state
          isSkillsLoading: true,
          skillsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllSkills.rejected, (state, action) => {
        state.allSkills = {
          ...initialState.allSkills,
          isSkillsLoading: false,
          isSkillsSuccess: false,
          skillsMessage: action.payload || 'Error occurred while fetching skills',
        };
      })

      // FULFILLED
      .addCase(getAllSkills.fulfilled, (state, action) => {
        state.allSkills = {
          ...initialState.allSkills,
          isSkillsLoading: false,
          isSkillsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          skills: action.payload || [],
        };
      });

    //Skill creating
    builder
      .addCase(addNewSkill.pending, (state) => {
        state.newSkill = {
          ...initialState.newSkill, // Reset to initial state
          isSkillCreating: true,
          skillCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewSkill.rejected, (state, action) => {
        state.newSkill = {
          ...initialState.newSkill,
          isSkillCreating: false,
          isSkillCreated: false,
          skillCreationMsg: action.payload || 'Error occurred while creating the skill.',
        };
      })

      // FULFILLED
      .addCase(addNewSkill.fulfilled, (state, action) => {
        state.newSkill = {
          ...initialState.newSkill,
          isSkillCreating: false,
          isSkillCreated: true,
          skillCreationMsg: action.payload || 'Successfully created the skill.',
        };
      });

    //Skill editing
    builder
      .addCase(editSkill.pending, (state) => {
        state.editedSkill = {
          ...initialState.editedSkill, // Reset to initial state
          isEditingSkill: true,
          skillEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editSkill.rejected, (state, action) => {
        state.editedSkill = {
          ...initialState.editedSkill, // Reset to initial state
          isEditingSkill: false,
          isSkillEdited: false,
          skillEditedMsg: action.payload || 'Error occurred while editing the skill.',
        };
      })

      // FULFILLED
      .addCase(editSkill.fulfilled, (state, action) => {
        state.editedSkill = {
          ...initialState.editedSkill, // Reset to initial state
          isEditingSkill: false,
          isSkillEdited: true,
          skillEditedMsg: action.payload || 'Successfully edited the skill.',
        };
      });
  },
});

export default skillsSlice.reducer;
